@if (colorMetaproducts.options) {
  <div class="color-metaproduct" [ngClass]="customClass">
    @if (showColorNameTitle) {
      <div>
        <span i18n="@@colorMetaproducts.chooseColor">Choose your color:</span>
        @if (selectedColor) {
          <span class="color-name"> {{ selectedColor }}</span>
        }
      </div>
    }
    @if (!showDropdown) {
      <ul class="color-selector">
        @for (product of colorMetaproducts.options; track product; let i = $index) {
          @if (product.color) {
            <li class="color-box" [ngClass]="{ selected: product.color.toLowerCase() === selectedColor.toLowerCase() }">
              <button
                class="color-box__circle"
                tabindex="0"
                role="button"
                data-gtmaction="event_buy_now_choose_product"
                data-gtmcategory="event_bin_action"
                [attr.data-gtmlabel]="product.color + '_' + product.title"
                [style]="'background-color: ' + translatetoHexcode(product)"
                (click)="gtmEvent($event); redirectToColorSelected(product.id, product.color, i)"
                (keypress)="redirectToColorSelected(product.id, product.color, i)"
              >
                <span class="sr-only">{{ product.color }}</span>
              </button>
            </li>
          }
        }
      </ul>
    } @else {
      <div class="dropup color__dropdown" [ngClass]="{ show: dropdownOpen() }">
        <button class="dropdown-toggle button" type="button" id="colorDropdown" (click)="toggleDropdown()">
          <span class="dropdown-toggle__text">
            <span class="dropdown-label"> <span i18n="@@COLOR">Color</span>: </span>
            <span class="dropdown-selected">{{ selectedColor }}</span>
          </span>
          <i class="fas fa-chevron-up"></i>
        </button>
        <ul class="dropdown-menu" aria-labelledby="colorDropdown" [ngClass]="{ show: dropdownOpen() }">
          @for (product of colorMetaproducts.options; track product; let i = $index) {
            @if (product.color) {
              <li class="dropdown-item" [ngClass]="{ selected: product.color === selectedColor }">
                <a
                  (click)="gtmEvent($event); redirectToColorSelected(product.id, product.color, i)"
                  (keypress)="redirectToColorSelected(product.id, product.color, i)"
                >
                  <span class="color-box" [ngClass]="{ selected: product.color === selectedColor }">
                    <span class="color-box__circle" [style]="'background-color:' + translatetoHexcode(product)"></span>
                  </span>
                  {{ product.color }}
                </a>
              </li>
            }
          }
        </ul>
      </div>
    }
  </div>
}
